module.exports = __webpack_public_path__ + "static/media/tinytap@2x.6aa9a203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companies/tinytap@2x.png
// module id = 80
// module chunks = 0